/* eslint-disable no-unused-vars */
import slick from 'slick-carousel';

export default () => {

  const $slider = $('.content-slider-slides');

  if ($slider.length) {
    $slider.slick({
      fade: true,
      adaptiveHeight: true,
      mobileFirst: true,
      prevArrow: '.content-slider-nav-button.-prev',
      nextArrow: '.content-slider-nav-button.-next',
      responsive: [{
        breakpoint: 767,
        settings: {
          adaptiveHeight: false
        }

      }]
    });
  }

};
